import logo from '../../assets/logo.svg';
import './Home.css';

function Home() {
  return (
    <section className="home">
      <div className="wrap">
        <h1 className="h3">SleeperCharger Admin CMS</h1>
        <img className="home__logo" src={logo} alt="" />
      </div>
    </section>
  );
}

export default Home;
